import styled, {css} from "styled-components"

export const RecipientContainer = styled.li`
  display: flex;
  align-items: center;
`
export const ExtraRecipient = styled.li`
  color: ${({theme}) => theme.colors.primary2};
`
export const ExpandList = styled.div`
  ${({theme}) => css`
    display: flex;
    align-items: center;
    color: ${theme.colors.primary2};
    img {
      margin-left: ${theme.spacing.one};
      width: 13px;
      height: 13px;
    }
  `}
`
export const ArrowUp = styled.img`
  transform: rotate(180deg);
`
